import {
  DRAWINGTOOLBAR_BACKGROUND_LOADED,
  BACKGROUND_IMAGE_LOADED,
  PDFDIALOG_PAGE_SELECT,
  PDFDIALOG_PAGE_CHANGE,
  PDFDIALOG_NUM_PAGES_CHANGE,
  PDFDIALOG_CLOSE
} from "../lib/types";

export const selectPage = bgImg => dispatch => {
  dispatch({
    type: DRAWINGTOOLBAR_BACKGROUND_LOADED,
    payload: bgImg
  });
  dispatch({
    type: BACKGROUND_IMAGE_LOADED,
    payload: bgImg
  });
  dispatch({
    type: PDFDIALOG_PAGE_SELECT
  });
};
export const closeDialog = () => dispatch => {
  dispatch({
    type: PDFDIALOG_CLOSE
  });
};

export const changePage = pageNumber => dispatch => {
  dispatch({
    type: PDFDIALOG_PAGE_CHANGE,
    payload: pageNumber
  });
};

export const changeNumOfPages = numPages => dispatch => {
  dispatch({
    type: PDFDIALOG_NUM_PAGES_CHANGE,
    payload: numPages
  });
};



// WEBPACK FOOTER //
// ./src/actions/pdfdialog-actions.js